import { FixedSizeList as List } from "react-window";
import styled from "styled-components";
import { SIDEBAR } from "../../../../constants";
import { zIndex } from "../../../../theme";

export const wrapperPadding = 8;

export const StyledWrapper = styled.div`
  background-color: var(--sinch-sys-color-container-main-default);
  height: calc(100vh - ${SIDEBAR.mobileHeight}px);
  border-radius: 8px;
  overflow-x: hidden;
  position: relative;
  font-family: var(--sinch-ref-typography-font-family-main);
`;

export const StyledSearchContainer = styled.div`
  position: sticky;
  width: 100%;
  top: 0;
  left: 0;
  padding: ${wrapperPadding}px;
  background-color: var(--sinch-sys-color-container-main-default);
  z-index: ${zIndex.overContent};
`;

export const StyledTreeContainer = styled.div`
  width: 100%;
`;

export const StyledList = styled(List)`
  padding-bottom: 8px;
`;
